
import Vue from 'vue'

export default Vue.extend({
  name: 'NavbarSmall',
  props: {
    showSecurePaymentInfo: {
      type: Boolean,
      default: true,
    }
  }
})
